//cameraStageController.js
export function createCameraStageController({
  camera,
  pointById,
  Utils,
  invalidate,
}) {
  function moveToStage(id) {
    const p = pointById.get(id);
    if (!p) return false;

    const c = Utils.getItemCenter(p);

    camera.tx = c.x;
    camera.ty = c.y;

    invalidate();
    return true;
  }

  return { moveToStage };
}
